<script>
	import { fade } from 'svelte/transition';
	import StarRating from 'svelte-stars-rating';

	export let book;

	let style = {
		styleStarWidth: 25,
		styleEmptyStarColor: "#737373",
		styleFullStarColor: "#ffd219"
	}

	function searchGoodreads(title) { 
		window.open( 
			"https://www.goodreads.com/search?q="+title, "_blank"); 
	} 

	const genreColorMap = {
		"literary fiction": "#00A8A7",
		"non-fiction": "#F2BC51",
		"graphic novel": "#9AD3DA",
		"memoir": "#FF904B",
		"sci-fi": "#03454A",
		"poetry": "#9C1B44",
		"essays": "#BA9987"
	}

</script>

<style>
	.flex-grid {
		display: flex
	}

	.flex-grid .col {
		flex: 1;
	}

	.img-holder {
		text-align: center;
		margin-top: 30px
	}

	.detail-holder {
		text-align: left
	}

	.col {
		padding: 2px
	}

	@media (max-width: 800px) {
		.flex-grid {
			display: block;
		}
		.col {
			width: 100%;
		}
	}

	p {
		text-align: left
	}

	h4 {
		text-align: left;
	}

	h2 {
		font-family: 'Rock Salt', cursive;
	}

	.review-text {
		font-style: italic;
		font-size: 18px
	}

	.card {
		max-width: 900px;
		grid-template-columns: 1fr 1fr;
		padding: 10px;
		background-color: white;
		box-shadow: 2px 2px 4px #dedede;
		border: 1px solid #888;
		margin: 0 auto;
		margin-bottom: 30px
	}

	.pill {
		display: inline-block;
		padding: 0.2em 0.5em;
		margin: 0 0.2em 0.2em 0;
		width: 110px;
		text-align: center;
		border-radius: 0.2em;
		font-weight: 600;
		color: white;
        background-color: bisque;
	}

	.goodreads-btn {
		border-radius: 0.2em;
		background-color: #F4F2E9;
		color: #463020;
		font-weight: 600;
		padding: 5px;
		border-width: 1px;
	}

	.goodreads-btn:hover {
		border-width: 2px;
	}

	.goodreads-btn span {
		margin-right: 3px;
		color: #463020
	}
</style>

<div class="container" style="min-height: 300px">
	{#if book}
	<div in:fade out:fade class="flex-grid card">
		<div class="col img-holder">
			<img width=180 src={book.cover} alt="">
		</div>
		<div class="col detail-holder">
			<h2 style="margin-bottom: -10px">{book.title}</h2>
			<span style="font-style: italic">by {book.author}</span>
			<span style="font-style: italic; float: right; margin-right: 20px">{book.pages} pages</span>
			<hr style="margin-right: 20px; margin-bottom: 10px">
			<span>My rating</span>
			{#if book.rating == 5}
				<StarRating id="star-rating" rating=5 {style}></StarRating>
			{:else if book.rating == 4}
				<StarRating id="star-rating" rating=4 {style}></StarRating>
			{:else if book.rating == 3}
				<StarRating id="star-rating" rating=3 {style}></StarRating>
			{:else if book.rating == 2}
				<StarRating id="star-rating" rating=2 {style}></StarRating>
			{:else if book.rating == 1}
				<StarRating id="star-rating" rating=1 {style}></StarRating>
			{/if}
			<hr style="margin-right: 20px; margin-bottom: -10px">
			<div class="flex-grid">
				<div class="col">
					<p style="font-weight: 600">Genre</p>
					<p class="pill" style="background-color: {genreColorMap[book.genre]}">{book.genre}</p>
				</div>
				<div class="col">
					<p style="font-weight: 600">Topics</p>
					<p>{book.topic}</p>
				</div>
			</div>
		</div>
		<div class="col">
			<h4 style="margin-top: 45px; margin-left: 5px">My review</h4>
			<p class="review-text" style="margin-left: 5px">"{book.review}"</p>
			<br>
			<button class="goodreads-btn" on:click={() => searchGoodreads(book.title)}> 
				<span>&#10175</span> Find on Goodreads
			</button>
		</div>
	</div>
	{/if}
</div>